<template>
  <main id="app" class="main-screen-sec" v-if="this.$route.name != '로그인'">
    <Header/>
    <Side/>
    <router-view/>
    <Footer/>
  </main>
  <main v-else="this.$route.name == '로그인'">
    <router-view/>
  </main>
</template>
<script>
import Header from "@/layout/app/partials/Header";
import Footer from "@/layout/app/partials/Footer";
import Side from "@/layout/app/partials/Side";

export default {
  name:"LayoutIndex",
  components: {Header,  Footer, Side},
  async created() {

  }
}
</script>
<style>

</style>